var _style, _g, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWestin = function SvgWestin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 172 82",
    style: {
      enableBackground: "new 0 0 172 82"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st122{fill:#696C71;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 162,
    height: 72
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M20.44,58.83l0.76-2.27l1.8-5.29h1.91l-3.62,9.78h-1.7l-3.62-9.78h1.91l1.8,5.29L20.44,58.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M30.05,51.16h2.02l3.5,9.74h-1.86l-0.75-2.18h-3.8l-0.75,2.18h-1.86L30.05,51.16z M30.55,54.51l-0.9,2.75 h2.83l-0.9-2.75l-0.52-1.63L30.55,54.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M42.65,59.46c1.29,0,1.86-0.48,2.03-1.63l1.74,0.18c-0.2,1.85-1.31,3.04-3.77,3.04 c-2.96,0-4.12-1.98-4.12-4.98s1.16-4.98,4.12-4.98c2.46,0,3.57,1.2,3.77,3.04l-1.74,0.19c-0.17-1.15-0.74-1.63-2.03-1.63 c-1.97,0-2.35,1.59-2.35,3.38C40.3,57.87,40.68,59.46,42.65,59.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M52.8,51.16h2.02l3.5,9.74h-1.86l-0.75-2.18h-3.8l-0.75,2.18H49.3L52.8,51.16z M53.29,54.51l-0.9,2.75h2.83 l-0.9-2.75l-0.52-1.63L53.29,54.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M64.55,60.89h-1.72v-8.01h-2.8v-1.6h7.32v1.6h-2.8V60.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M72.93,60.89H71.2v-9.61h1.72V60.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M77.18,56.09c0-3.03,1.27-4.98,4.31-4.98c3.05,0,4.31,1.95,4.31,4.98c0,3.03-1.27,4.98-4.31,4.98 C78.45,61.07,77.18,59.12,77.18,56.09z M78.93,56.09c0,1.82,0.51,3.38,2.56,3.38s2.55-1.55,2.55-3.38s-0.49-3.38-2.55-3.38 S78.93,54.26,78.93,56.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M92.54,55.94l-0.95-1.48l0.02,2.31v4.13h-1.73v-9.61h1.59l3.32,4.95l0.95,1.48l-0.02-2.31v-4.13h1.72v9.61 h-1.59L92.54,55.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M110.83,59.46c1.29,0,1.86-0.48,2.03-1.63l1.74,0.18c-0.2,1.85-1.31,3.04-3.77,3.04 c-2.96,0-4.12-1.98-4.12-4.98s1.16-4.98,4.12-4.98c2.47,0,3.57,1.2,3.77,3.04l-1.74,0.19c-0.17-1.15-0.74-1.63-2.03-1.63 c-1.97,0-2.35,1.59-2.35,3.38C108.47,57.87,108.85,59.46,110.83,59.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M120.32,59.29h4.56v1.6h-6.29v-9.61h1.73V59.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M128.06,57.38v-6.1h1.73v6.1c0,1.17,0.37,2.08,2.19,2.08s2.19-0.91,2.19-2.08v-6.1h1.72v6.1 c0,2.1-0.92,3.68-3.92,3.68S128.06,59.48,128.06,57.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M140.14,60.89v-9.61h4.12c1.22,0,2.86,0.44,2.86,2.66c0,1-0.43,1.63-0.87,1.91 c0.68,0.28,1.18,1.07,1.18,2.23c0,2.34-1.48,2.81-3.11,2.81H140.14z M141.87,52.88v2.29h2.27c0.74,0,1.21-0.22,1.21-1.17 c0-0.92-0.46-1.12-1.21-1.12H141.87z M144.23,59.29c0.57,0,1.43-0.07,1.43-1.23c0-1.16-0.75-1.28-1.38-1.28h-2.42v2.51H144.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M53.08,10.93h-8.16c0.88,0.44,1.4,1.49,1.4,2.63c0,1.05-0.31,2.5-0.92,4.12l-4.08,11.27L34,10.93h-6.58 c1.84,1.4,2.72,4.25,1.36,7.41l-4.82,11.14l-7.28-18.55H9c1.23,0.83,2.15,2.76,3.25,5.44l7.5,18.81c1.01,2.54,2.15,3.86,4.56,5 l7.81-17.59l5.35,12.59c1.1,2.5,2.19,3.86,4.6,5L53.08,10.93L53.08,10.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M70.47,34.75c-1.89,1.4-3.86,2.02-6.62,2.02c-1.49,0-2.81-0.13-3.77-0.35v-7.19h2.02 c2.46,0,3.29,0.18,3.95,0.92v-4.21h-5.96v-5.92c0,0,0.92-0.13,2.81-0.13c2.19,0,3.73,0.35,4.61,1.32v-4.34h-14.3 c1.14,0.61,1.32,1.53,1.32,5.35v12.24c0,3.81-0.18,4.74-1.32,5.35h15.66L70.47,34.75L70.47,34.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M88.98,32.69c0-7.02-10.66-6.54-10.66-10.83c0-1.27,1.14-2.37,3.11-2.37c2.11,0,3.91,0.74,5.88,2.63v-5 c-2.02-0.53-3.64-0.83-5.66-0.83c-4.38,0-8.86,2.63-8.86,6.97c0,7.89,10.66,6.75,10.66,11.18c0,1.58-1.4,2.72-3.81,2.72 c-2.72,0-5.35-1.09-8.07-3.46l1.45,5.48c2.19,0.79,4.03,1.19,6.05,1.19C84.68,40.36,88.98,37.29,88.98,32.69L88.98,32.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M109.35,16.86H90.62l-1.27,4.34c1.41-0.96,2.67-1.32,5-1.32h2.24v14.56c0,3.81-0.18,4.74-1.36,5.35h8.2 c-1.14-0.62-1.32-1.54-1.32-5.35V19.88h1.98c2.06,0,3.46,0.31,4.17,1.32L109.35,16.86L109.35,16.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M120.09,39.79c-1.14-0.62-1.31-1.54-1.31-5.35V22.21c0-3.82,0.17-4.74,1.31-5.35h-8.2 c1.14,0.61,1.32,1.53,1.32,5.35v12.24c0,3.81-0.18,4.74-1.32,5.35H120.09L120.09,39.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M147.32,16.86h-7.5c1.49,0.79,1.67,2.46,1.67,5v9.3l-9.6-11.4c-0.96-1.18-1.62-2.06-2.24-2.89h-6.62 c1.36,0.79,2.02,2.28,2.02,5.39v12.54c0,2.55-0.17,4.21-1.67,5h7.5c-1.49-0.79-1.67-2.46-1.67-5v-9.47l9.91,11.75 c1.41,1.67,3.2,2.37,6.54,2.89V21.85C145.66,19.31,145.88,17.64,147.32,16.86L147.32,16.86z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M148.56,19.96c0-1.15,0.87-2.02,1.98-2.02c1.1,0,1.97,0.87,1.97,2.02c0,1.17-0.87,2.03-1.97,2.03 C149.43,21.99,148.56,21.13,148.56,19.96z M150.54,22.39c1.33,0,2.46-1.03,2.46-2.44c0-1.39-1.13-2.42-2.46-2.42 c-1.34,0-2.47,1.03-2.47,2.42C148.07,21.37,149.2,22.39,150.54,22.39z M150.03,20.15h0.49l0.74,1.22h0.48l-0.8-1.24 c0.41-0.05,0.73-0.27,0.73-0.77c0-0.55-0.33-0.8-0.99-0.8h-1.07v2.8h0.43V20.15z M150.03,19.79v-0.87h0.58 c0.29,0,0.61,0.07,0.61,0.41c0,0.43-0.32,0.46-0.68,0.46H150.03z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWestin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/westin.ba80a3ec.svg";
export { ForwardRef as ReactComponent };